import ReceivablesTableSearchQuery from '../models/receivablesTableSearchQuery';

enum ReceivablesTableQueryType {
  GetDropdownOptions,
  GetPage,
  DeletePaymentRequest,
}

interface QueryGetDropdownOptions {
  type: ReceivablesTableQueryType.GetDropdownOptions;
}

interface QueryGetPage {
  type: ReceivablesTableQueryType.GetPage;
  query: ReceivablesTableSearchQuery;
}

interface QueryDeletePayment {
  type: ReceivablesTableQueryType.DeletePaymentRequest;
  paymentRequestId: string;
}

type ReceivablesTableQuery = QueryGetDropdownOptions | QueryGetPage | QueryDeletePayment;

export { ReceivablesTableQueryType };
export default ReceivablesTableQuery;
